module.exports = __webpack_public_path__ + "img/central_blitz-min.34d162cf.jpg";